import Component from '@glimmer/component'
import { hash } from '@ember/helper'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import type { CustomCellSignature } from 'teacher-ui-client/components/stable-table/basic-table/cell'

export class BookDetailCell extends Component<CustomCellSignature> {
  get row() {
    return this.args.tableMeta.rowObject
  }

  <template>
    <LinkTo
      data-test-book-id={{this.row.id}}
      class="text-oceany-blue-350 block text-left font-bold print:hidden"
      @query={{hash bookId=this.row.id}}
    >
      {{t "bookLibrary.viewBookDetails"}}
    </LinkTo>
    {{#if this.row.bookDescription}}
      <span class="hidden print:inline">{{this.row.bookDescription}}</span>
      <span class="print:hidden">{{this.row.bookDescriptionTruncated}}</span>
    {{/if}}
  </template>
}

export default BookDetailCell
